import { CommonUtilsService } from 'util/services/commonUtilsService';
import { ShareBaseNotification } from '../../phoenix/domain/sharebase-notification';
import { ClientNotification } from '../domain';
import { TokenStringFilter } from '../../phoenix/filters/tokenString';



export class NotificationFactory {
	public static $inject = [
		'$state',
		'pxTokenStringFilter',
		'utils'
	];

	constructor(
		private readonly $state,
		private readonly pxTokenStringFilter:TokenStringFilter,
		private readonly utils:CommonUtilsService
	) {}

	public create(sbNotification:ShareBaseNotification) {
		return new ClientNotification(sbNotification, this.$state, this.utils, this.pxTokenStringFilter);
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/factories/notificationFactory.ts